import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {FolderList} from "./folder/folder-list";
import Drawer from "@material-ui/core/Drawer";
import React, { useState } from "react";
import {createStyles, makeStyles, Theme, useTheme} from "@material-ui/core/styles";
import { AppBar, Box, Tab } from "@material-ui/core";
import { PanelProps, TabPanel, TabProps } from "./tabs";
import Tabs from "@material-ui/core/Tabs/Tabs";
import { Measurements } from "./measurements/measurements";
import { PromptDialog } from "./dialogs";

export const assetDrawerWidth = 280;
export const assetDrawerHeight = 75;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      display: "none"
    },
    inside: {
      height: `${assetDrawerHeight}%`,
      display: "flex",
      overflow: "hidden",
      flexDirection: "column"
    },
    drawer: {
      width: 0,
    },
    drawerPaper: {
      width: assetDrawerWidth,
    },
    root: {
      "z-index": `${theme.zIndex.modal - 1} !important`
    },
    tab: {
      "min-width": "0px !important"
    },
    box: {
      padding: "10px 0px 0px 0px !important",
      height: "calc(100% - 10px)",
      overflow: "auto",
      display: "flex",
      flexDirection: "column"
    },
    tabGrow: {
      "flex-grow": 1
    },
    panel: {
      flex: 1,
      overflow: "hidden"
    }
  }),
);

export const AssetDrawer = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const {assetDrawerState, viewer, measurements, activeTab, setTabValue,
    tabsEnabled, setDefaultTab, setAssetDrawerState, clearTooltipText} = props;

  const [activeMeasurePrompt, setActiveMeasurePrompt] = useState(false);
  const [newTabValue, setNewTabValue] = useState(null);
  const [closeDrawer, setCloseDrawer] = useState(false);

  const measurementsOpen = activeTab === 1;
  const hasMeasurements = measurements.length > 0;

  const setActiveTab = (event, value) => {
    // Tab navigation disabled
    if (tabsEnabled === false) {
      return;
    }

    if (measurementsOpen && hasMeasurements) {
      setCloseDrawer(false);
      setNewTabValue(value);
      setActiveMeasurePrompt(true);
      return;
    }

    setTabValue(value);
  };

  const handleDrawerClose = () => {
    if (measurementsOpen && hasMeasurements) {
      setCloseDrawer(true);
      setNewTabValue(0);
      setActiveMeasurePrompt(true);
      return;
    }

    setDefaultTab();
    setAssetDrawerState(false);
  };

  const onModalClose = () => {
    setTabValue(newTabValue);

    if (closeDrawer) {
      setAssetDrawerState(false);
    }
  };

  const handleClose = () => {
    setActiveMeasurePrompt(false);
  };

  return (
    <React.Fragment>
      <Drawer
        className={classes.drawer}
        anchor="left"
        open={assetDrawerState}
        transitionDuration={0}
        classes={{
          paper: classes.drawerPaper,
          root: classes.root
        }}
        BackdropProps={{
          classes: {
            root: classes.backdrop
          }
        }}
      >
        <div className={classes.inside}>
          <AppBar position="static" color="default">
            <Box display="flex" flexDirection="row">
              <Tabs
                value={activeTab}
                onChange={setActiveTab}
                indicatorColor="primary"
                variant="fullWidth"
                textColor="primary"
                className={classes.tabGrow}
              >
                <Tab label="Manage" className={classes.tab} {...TabProps(0)} />
                <Tab label="Measure" className={classes.tab} {...TabProps(1)} />
              </Tabs>
              <IconButton onClick={handleDrawerClose}>
                {theme.direction === 'ltr' ? <ChevronLeftIcon/> : <ChevronRightIcon/>}
              </IconButton>
            </Box>
          </AppBar>

          {/* Assets */}
          <TabPanel classes={classes} {...PanelProps(activeTab, 0)}>
            <FolderList viewer={viewer}/>
          </TabPanel>

          {/* Measurements */}
          <TabPanel classes={classes} {...PanelProps(activeTab, 1)}>
            <Measurements
              active={measurementsOpen}
              measurements={measurements}
              clearTooltipText={clearTooltipText}
              viewer={viewer}
            />
          </TabPanel>

        </div>
      </Drawer>

      {/* Discard measurements dialog */}
      <PromptDialog
        open={activeMeasurePrompt}
        onCancel={handleClose}
        onSubmit={() => {
          onModalClose();
          handleClose();
        }}
        title="Discard measurements?"
        prompt="Active measurements found, do you want to discard measurements?"
        button="Discard"
      />

    </React.Fragment>
  );
};